import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";

export class WirelineChangeVendorDetails extends Component {
    constructor(props) {
        super(props);
    }

    //renderPlanComponents = props => {
    //    return props != null && props.length != 0
    //        ? props.map((item, i) => (
    //            <tr key={i}>
    //                <td>{i === 0 ? "Plan Details" : null}</td>
    //                <td>{item.ComponentName}</td>
    //            </tr>
    //        ))
    //        : null;
    //};

    render() {
        const { data, isWireline } = this.props;
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.OldVendorDetailName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.SimType.SimTypeName}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="change_to_reqular" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.NewRequest.Vendor && data.NewRequest.Vendor.VendorName}</td>
                            </tr>
                            {data.Subscription.OrderOption !== null && data.Subscription.OrderOptionId > 0 &&
                                <tr>
                                    <td><Translation translationKey="order_option" /></td>
                                    <td>{data.Subscription.OrderOption}</td>
                                </tr>
                            }
                            {data.Subscription.EquipmentCatalogId !== null && data.Subscription.EquipmentCatalogId > 0 &&
                                <tr>
                                    <td><Translation translationKey="mobile_service_type" /></td>
                                    <td>{data.Subscription.EquipmentCatalog}</td>
                                </tr>
                            }
                            <tr>
                                <td><Translation translationKey="plan_name" /></td>
                                <td>{data.Subscription.PlanDetails && data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="plan_details" /></td>
                                <td>{data.Subscription.PlanDetails && data.Subscription.PlanDetails.PlanComponents > 0
                                    ? data.Subscription.PlanDetails.PlanComponents.map(p => p.ComponentName).join("; ")
                                    : ''}</td>
                            </tr>
                            {/*this.renderPlanComponents(data.Subscription.PlanDetails.PlanComponents)*/}
                            <tr>
                                <td><Translation translationKey="plan_amount" /></td>
                                <td>{data.Subscription.PlanDetails.Monthly.toFixed(2)} {data.Subscription.PlanDetails.Currency.CurrencyName} per month</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="sim_type" /></td>
                                <td>{data.SimType.SimTypeName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}